export { default } from './AlertsCenterHeader';
